import * as React from "react";
const SvgFiRrMotorcycle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 11q-.3 0-.6.036l-.607-1.82a15 15 0 0 1 1.493-.187C19.767 10.053 21.909 10.543 22 9V7c-.1-1.574-2.293-1.033-2.747.026q-1.018.069-2.02.259l-.079.016-.522-1.566A3.99 3.99 0 0 0 12.838 3H11a1 1 0 1 0 0 2h1.838a2 2 0 0 1 1.9 1.368l.553 1.659c-.45.27-.863.596-1.228.973H8.825A3 3 0 0 0 6 7H3a1 1 0 0 0 0 2h3a.98.98 0 0 1 .895.553c.061.123.097.258.105.395a1.6 1.6 0 0 1-.2.652l-.44.586A5.026 5.026 0 0 0 0 16c.114 6.163 8.966 6.763 9.947.726A4 4 0 0 0 11.7 15.4l3.451-4.6q.373-.424.794-.8l.555 1.67A5.015 5.015 0 0 0 19 21c6.608-.21 6.606-9.791 0-10M5 19a3 3 0 0 1 0-6l-.6.8A2 2 0 0 0 6 17h1.828A3 3 0 0 1 5 19m5.1-4.8a2.01 2.01 0 0 1-1.6.8H6l2.4-3.2a3 3 0 0 0 .431-.8H12.5zM19 19a3.013 3.013 0 0 1-1.842-5.365l.894 2.681a1.002 1.002 0 0 0 1.9-.632L19.054 13A3 3 0 0 1 19 19"
    />
  </svg>
);
export default SvgFiRrMotorcycle;
